import React from 'react'
import logo from './logo-final.svg';
import './login.css';

export const LoginLoader = () => {
    return (
        <div className="skeleton-container justify-content-center  align-items-center  d-flex 
			flex-column body-gradient"
            style={{ top: '0px', bottom: '0px', left: '0px', right: '0px', position: 'fixed' }}>
            <div className="
                miclase col-lg-4 col-md-6 col-sm-12 
                bg-white shadow
                d-flex flex-column
                align-items-center
                justify-content-center
                p-1">
                <div className="w-100 text-center">
                    <img src={logo} alt="" />
                </div>
            </div>
        </div>
    )
}
